import { Stack } from '@mui/material';
import type { FlowPlaylistSource } from '@/helpers/flow-media-playlist.helper';
import { FlowPlaylistMediaWidget } from '@/components/flows/detail/edit-details/flow-playlist-media-widget';

export function FlowEndSlotAssetsDetails({ flow }: { flow: FlowPlaylistSource }) {
  const liveReady = flow.liveContext?.isRunning ?? false;
  return (
    <Stack spacing={2}>
      <FlowPlaylistMediaWidget flow={flow} scope="flow_outro" liveReady={liveReady} />
      <FlowPlaylistMediaWidget flow={flow} scope="after_flow" liveReady={liveReady} />
    </Stack>
  );
}
